module.exports = __webpack_public_path__ + "media/iconic/minus-f3b2c90b.svg";